import React from 'react'
import { TrashIcon, ChartPieIcon } from '@heroicons/react/outline'
import { Link } from 'react-router-dom'

const ContentRow = (props) => {
  return (
    <div className="flex items-center gap-5 p-3 rounded-lg hover:bg-slate-50">
        <div className="w-1/5">{props.data.date}</div>
        <div className="w-1/2">
          <Link to={`/contents/${props.data.id}`} className="text-blue-600 cursor-pointer hover:text-blue-700">
            {props.data.title}
          </Link>
        </div>
        <div className="w-1/12">{props.data.count_docs}</div>
        <div className="w-1/12">{props.data.count_videos}</div>
        <div className="w-1/12">{props.data.count_quizzes}</div>
        <div className="flex justify-end gap-2 w-14">
          <Link to={`/contents/${props.data.id}/analytic`} className="cursor-pointer hover:text-blue-600">
            <ChartPieIcon className="w-6 h-6" />
          </Link>
          <TrashIcon className="w-6 h-6 cursor-pointer hover:text-red-500" onClick={() => props.clickDelete(props.data.id)} />
        </div>
    </div>
  )
}

export default ContentRow